// Generated by purs version 0.15.15
import * as Ouroboros_Services_FFI_PendingEmailValidation from "../Ouroboros.Services.FFI.PendingEmailValidation/index.js";
var setPendingEmailValidation = Ouroboros_Services_FFI_PendingEmailValidation.setPendingEmailValidation;
var getPendingEmailValidation = Ouroboros_Services_FFI_PendingEmailValidation.getPendingEmailValidation;
export {
    getPendingEmailValidation,
    setPendingEmailValidation
};
//# sourceMappingURL=index.js.map
